import script from "./print-shipping-report.vue?vue&type=script&setup=true&lang=ts"
export * from "./print-shipping-report.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__